/*
 * Get single clinical trial
 */
import { clientFetch } from '../clientFetch';

export const getTrial = ({ id, ...params }) => {
  return clientFetch(`/entity/clinical-trial/${id}`, { params });
};
